export const exceptionHandler = (rejectWithValue, e) => {
  return rejectWithValue({
    name: e.body?.title,
    code: e.status,
  });
};
